export const topBarHeight = "77px";
export const topBarHeightSubtitle = "120px";
export const appLoaderHeight = 2;
export const savebarHeight = "64px";
export const borderHeight = "1px";
